// extracted by mini-css-extract-plugin
export default {"textDocumentViewer":"styles_textDocumentViewer__JC0MG","content":"styles_content__2r75w"};